export const desiredLifetimeOptions = [
  { value: 0, label: '1 week' },
  { value: 1, label: '1 month' },
  { value: 2, label: '3 months' },
  { value: 3, label: '6 months' },
  { value: 4, label: '1 year' },
]
